import { type SvgProps } from "react-native-svg"

export interface MyLeadsConnectViewProps {
  darkTheme?: boolean
  onDismiss?: () => void
}

// Interface for a single slide
export interface CarouselSlide {
  title: string
  subtitle?: string
  icon?: React.FC<SvgProps> // React.FC<React.SVGProps<SVGSVGElement>>
  lottieFile?: string
  graphicHeight?: number
}

// Interface for the carousel data
export interface CarouselData {
  ctaText: string
  slides: CarouselSlide[]
}

export const carouselAData: CarouselData = {
  ctaText: "Get My Leads Now",
  slides: [
    {
      title: "Sourcing\non Auto-Pilot\nin Your Pocket",
      lottieFile: "myleads-a-1",
    },
    {
      title: "Your Custom \n" + "Buy Box",
      lottieFile: "myleads-a-2",
    },
    {
      title: "Auto-Analyze\n" + "All Leads",
      lottieFile: "myleads-a-3",
    },
    {
      title: "Introducing\n" + "My Leads!",
      subtitle:
        "Spend less time on busy work and\nmore time closing deals and growing\nyour business.",
      lottieFile: "myleads-a-4",
    },
  ],
}

export const carouselBData: CarouselData = {
  ctaText: "Try My Leads",
  slides: [
    {
      title: "Your Property Leads, \n" + "All in One Private Feed",
      subtitle:
        "Pull leads scattered across your email into My Leads, your centralized feed with all of your fix & flip opportunities",
      lottieFile: "myleads-b-1",
      graphicHeight: 285,
    },
    {
      title: "Beat the Competition to\n Every Flipping Deal",
      subtitle:
        "Turn on My Leads alerts to receive real-time alerts on high-potential property leads that match your buy box",
      lottieFile: "myleads-b-2",
      graphicHeight: 310,
    },
    {
      title: "Connect your Gmail to\nGet Started",
      subtitle:
        "Backflip will keep your data private and never share with 3rd parties",
      lottieFile: "myleads-b-3",
      graphicHeight: 310,
    },
  ],
}
